/** Cap for the sender's greeting on a voucher — enforced on the server and in both UIs. */
export const VOUCHER_PERSONAL_MESSAGE_MAX_LENGTH = 300;

export enum VoucherTypes {
  AMOUNT = 'amount',
  SERVICE = 'service'
}

export interface IVoucher {
  _id?: string;
  id: string;
  bid: string;
  voucherType: VoucherTypes;
  amount?: number;
  serviceId?: string[];
  serviceDiscount?: number;
  validFromDate: Date | string;
  validUntilDate: Date | string;
  message?: string;
  /**
   * Free-text greeting written by whoever sent the voucher (business owner or the
   * buyer on the business site). Shown to the recipient on the voucher page.
   * Distinct from `message`, which carries the template's marketing copy.
   */
  personalMessage?: string;
  sentTo: 'self' | string;
  used: boolean;
  usedAt?: Date;
  paid?: boolean;
  templateId?: string;
  buyerCustomerId?: string;
  recipientFullName?: string;
}
